import Public from './routes/Public/public';
import Login from './routes/Auth/login';
import Panel from './routes/Panel/panel';
import Certificate from "./routes/Certificate/public";
import NotFound from "./components/views/panel/partials/NotFound";

export const routes = [
    {...Certificate},
    {...Public},
    {...Login},
    {...Panel},
];
